import React from "react";
import axios from "axios";
import SearchForm from "../../component/SearchForm";
import { Link, withRouter } from "react-router-dom";
import Pagination from "../../component/Pagination";
import ReactHtmlParser from 'react-html-parser';
import InvoiceStatus from "../../component/InvoiceStatus";
import AlertLabel from "../../component/AlertLabel";
import InvoiceRequestModal from "./modals/InvoiceRequestModal";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
import { InvoicePDFTemplate } from "./pdf_template/InvoicePDFTemplate";
import DeliveryStatus from "../../component/DeliveryStatus";
import ItemRegisModal from "./modals/ItemRegisModal";
import TaduNoteModal from "./modals/TaduNoteModal";
import { connect } from "react-redux";
import VATStatus from "../../component/VATStatus";
import ChangeServiceInfo from "./modals/ChangeVPSTemplate";
import { toast, ToastContainer } from "react-toastify";
import BlockUI from "../../component/BlockUI";
import ChangeDomainProfileModal from "./modals/ChangeDomainProfileModal";
import { InvoicePageRole } from "../../component/UserPermission";
import ItemRenewModal from "./modals/ItemRenewModal";
import FileRender from "../../component/FileRender";

var numeral = require("numeral");
var _ = require('lodash');

function EnumTranslate(str) {
  switch(str) {
    case "BANK_TRANSFER": {
      return "Đã thanh toán và chuyển khoản";
    }
    case "TADU_ACCOUNT": {
      return "Thanh toán bằng tài khoản chính Tadu";
    }
    case "REWARD_ACCOUNT": {
      return "Thanh toán bằng tài khoản khuyến mãi Tadu";
    }
    case "AGENCY": {
      return "Đại lý";
    }
    case "CUSTOMER": {
      return "Khách hàng của đại lý";
    }
    default: {
      return "";
    }
  }
}

function ServiceInfoChangeBtn(user_role, item,onChangeServiceInfo) {
  return (
    InvoicePageRole.isServiceInfoChange(user_role) && <span onClick={()=>onChangeServiceInfo(item)} style={{color:"#42A5F5", cursor: 'pointer'}}> [ Sửa ]</span>
  )
} 

function DomainProfileModifyBtn(user_role, item, onChangeDomainProfile) {
  let inner_btn = null;
  if(InvoicePageRole.isModifyDomainProfile(user_role) && item.domain_profile_id && !item.parent_id && !item.is_delivery && !item.is_renew) {
    inner_btn = <span onClick={()=>onChangeDomainProfile(item)} style={{color:"#42A5F5", cursor: 'pointer'}}> 
      <i className="icon-pencil7"></i>
    </span>
  }
  return inner_btn;
}

function AddonPriceLabel(parent_service, invoice_list) {
  const has_who_is_privacy = _.find(invoice_list,(i) => i.parent_id == parent_service.group_id)
  const ip_addon_items = _.filter(invoice_list,(i) => i.product.product_type =="IP" && i.parent_id == parent_service.group_id)
  const ip_addon_sum = _.sumBy(ip_addon_items, (i) => i.price);
  let inner_addon_price_html = null;
  if(has_who_is_privacy) {
    inner_addon_price_html = (
      <span className="text-orange">+ {numeral(has_who_is_privacy.price).format("0,0")} đ</span>
    )
  }
  if (ip_addon_items.length > 0) {
    inner_addon_price_html = (
      <span className="text-orange">+ {numeral(ip_addon_sum).format("0,0")} đ</span>
    )
  }
  return inner_addon_price_html;
}

// Thông tin IP mua thêm cho VPS, HOSTING
function IPAddonLabel(user_role, item) {
  return (
    <React.Fragment>
      <span>
        {item.product.product_type}
        <br/>
        {item.user_product && ["VPS", "CLOUD_SERVER_PRO"].includes(item.user_product.product.product_type) && <strong> VPS # {item.user_product.ip_address}</strong>}
        {item.user_product && ["WINDOW_HOSTING", "LINUX_HOSTING"].includes(item.user_product.product.product_type) && <strong> Hosting # {item.domain}</strong>}
        <br/>
        <small className="text-muted"> Số lượng: {item.quantity} IP</small>
      </span>
    </React.Fragment>
  )
}

// Thông tin IP mua thêm cho VPS, HOSTING
function WhoIsAddonLabel(item) {
  return (
    <React.Fragment>
      <span>
        <strong>{item.product.product_type}</strong>
        <br/>
        {item.user_product && ["COM_DOMAIN"].includes(item.user_product.product.product_type) && <small className="text-muted"> Tên Miền # {item.domain}</small>}
      </span>
    </React.Fragment>
  )
}

// Thông tin dịch vụ VPS.
function VPSLabel(user_role, item, onChangeServiceInfo, templates, addon_services) {
  const template =  _.find(templates, (i) => i.id == item.template_id);

  return (
    <React.Fragment>
      <div>
        <span>
          {item.product.name} {template && <strong>{template.name} {template.version}</strong> }
        </span>
        {!item.user_product && ServiceInfoChangeBtn(user_role, item, onChangeServiceInfo)}
      </div>
      {/* Thông tin dịch vụ sẽ được hiện ra sau khi kỹ thuật khởi tạo thông tin đăng nhập */}
      {item.user_product && <div className="text-muted">
        <p>IP: {item.user_product.ip_address}</p>
        {InvoicePageRole.isShowUserProductInfo(user_role) && <span>
          <p>Code: {item.user_product.domain}</p>
          <p>Server: {item.user_product.server_ip_address}</p>
          <p>Username: {item.user_product.username}</p>
          <p>Password: {item.user_product.password_decrypt}</p>
        </span>}
      </div>}
      {addon_services.length > 0 && <span className="text-orange">Tổng số IP: {addon_services.length}</span>}
      <div></div>
      
    </React.Fragment>
  )
}

// Thông tin dịch vụ Domain.
function DomainLabel(user_role, item, onShowItemRegisModal , onRenewWhoisService, role_path, addon_services) {
  const whois_setup_style = {color:"#42A5F5", cursor: 'pointer'};
  const whois_item = addon_services.length > 0 && addon_services[0];

  return (
    <React.Fragment>
      <span>{item.product.name} <strong>{item.domain}</strong></span> 
      {item.is_tranfer && <span><br />Auth Code: <strong className="text-pink">{item.auth_code}</strong></span>}
      {whois_item && 
        <div>
          <small className={whois_item.is_delivery ? "text-orange" : "text-muted"}> + {whois_item.product.name} </small>
          {item.is_delivery && !whois_item.is_delivery && 
            <span>
              {/* Gia hạn WHOIS */}
              {whois_item.is_renew && <small onClick={() => onRenewWhoisService(item.id, whois_item)} style={whois_setup_style}>[ Gia Hạn ]</small>}
              {/* Đăng ký mới WHOIS */}
              {!whois_item.is_renew && <small onClick={() => onShowItemRegisModal(whois_item)} style={whois_setup_style}>[ Khởi Tạo ]</small>}
            </span>}
        </div>}
    </React.Fragment>
  )
}

// Thông tin dịch vụ HOSTING.
function HostingLabel(user_role, item, onChangeServiceInfo, addon_services) {
  return (
    <span>
      <span className="text-muted">{item.product.product_type} </span>
      <br/>
      {item.product.name} <strong>{item.domain}</strong>
      {item.user_product && InvoicePageRole.isShowUserProductInfo(user_role) && <div className="text-muted">
        <p>Server: {item.user_product.server_ip_address}</p>
        <p>Username: {item.user_product.username}</p>
        <p>Password: {item.user_product.password_decrypt}</p>
      </div>} 
      {addon_services.length > 0 && <span className="text-orange">Tổng số IP: {addon_services.length}</span>}
    </span>
  )
}

// Thông tin dịch vụ Email.
function EmailLabel(user_role, item, onChangeServiceInfo) {
  return (
    <span>
      <br/>
      {item.product.name} <strong>{item.domain}</strong>
      {item.user_product && InvoicePageRole.isShowUserProductInfo(user_role) && <div className="text-muted">
        <p>Server: {item.user_product.server_ip_address}</p>
        <p>Username: {item.user_product.username}</p>
        <p>Password: {item.user_product.password_decrypt}</p>
        <p>DKIM: {item.user_product.dkim}</p>
        <p>ID: {item.user_product.email_domain_key}</p>
      </div>}
    </span>
  )
}

// Thông tin dịch vụ SSL.
function SSLLabel(user_role, item, onChangeServiceInfo) {
  // Đối với SSL Wildcard cần phải có tiền tố *.
  const ssl_file_name = item.product_id === 372 ? `*.${item.domain}-${item.id}.key` : `${item.domain}-${item.id}.key`
  return (
    <span>
      {item.product.name} <strong>{item.domain}</strong>
      {item.user_product && InvoicePageRole.isShowUserProductInfo(user_role) && <div className="text-muted">
        <p>Host: {item.user_product.ssl_key}</p>
        <p>SSL Value: {item.user_product.ssl_value}</p>
        {item.is_delivery && <p> 
          <i className="icon-download7"></i> 
          <FileRender directory="private_key" file_name={ssl_file_name} isDisplay={false} />
        </p>}
      </div>}
    </span>
  )
}

// Thông tin dịch vụ Taduphone.
function TaduphoneLabel(user_role, item, onChangeServiceInfo) {
  return (
    <span>
      <br/>
      {item.product.name}
      {item.user_product && InvoicePageRole.isShowUserProductInfo(user_role) && <div className="text-muted">
        <p>Số Tổng Đài: {item.user_product.domain}</p>
        <p>Username: {item.user_product.username}</p>
        <p>Password: {item.user_product.password_decrypt}</p>
      </div>}
    </span>
  )
}

// Thông tin dịch vụ Tadu Invoice.
function TaduInvoiceLabel(user_role, item, onChangeServiceInfo) {
  return (
    <span>
      <br/>
      {item.product.name} <strong>{item.domain}</strong>
    </span>
  )
}

// Thông tin dịch vụ Cloud Backup.
function CloudBackupLabel(user_role, item, onChangeServiceInfo) {
  return (
    <React.Fragment>
      <div>
        <br/>
        {item.product.name} <strong>{item.domain}</strong>
      </div>
      {item.user_product && InvoicePageRole.isShowUserProductInfo(user_role) && <div className="text-muted">
        <p>Server: {item.user_product.server_ip_address}</p>
        <p>Username: {item.user_product.username}</p>
        <p>Password: {item.user_product.password_decrypt}</p>
      </div>}
    </React.Fragment>
  )
}

// Thông tin dịch vụ Digital Signature (Chữ ký số).
function DigitalSignatureLabel(user_role, item, onChangeServiceInfo) {
  return (
    <div>
      {item.product.name} <strong>{item.domain}</strong>
    </div>
  )
}


function CheckItemRegisStatus(item) {
  let item_status = (
    <span className="badge badge-flat border-success text-success-600">
      Đăng ký mới
    </span>
  )
  if(item.is_renew) {
    item_status = (
      <span className="badge badge-flat border-primary text-primary-600">
        Gia Hạn
      </span>)
  }else if(item.is_upgrade) {
    item_status = (
      <span className="badge badge-flat border-info text-info-600">
        Nâng Cấp
      </span>)
  } else if (item.is_tranfer) {
    item_status = (
      <span className="badge badge-flat border-danger text-danger-600">
        Chuyển về TADU
      </span>)
  }
  return item_status;
}

// Setup trước
function SetupProductBtn(invoice_id, onSetInvoiceTrial) {
  return (
    <button onClick={() => onSetInvoiceTrial(invoice_id)} style={{ marginRight: 10 }} type="button" className="btn bg-purple-400 btn-ladda btn-ladda-progress">
      Setup Trước{" "}<i className="icon-pushpin"></i>
    </button>
  )
}

// Thanh toán bằng Paypal
function PaypalPaidBtn(invoice) {
  return (
    <button style={{ marginRight: 10 }} type="button" className="btn bg-slate btn-ladda btn-ladda-progress">
      Thanh Toán Qua Paypal{" "}<i className="icon-paypal"></i>
    </button>
  )
}
// Tính lại giá
function ReCalculatePriceBtn(invoice) {
  return (
    <button style={{ marginRight: 10 }} type="button" className="btn bg-brown">
      Tính Lại Giá{" "}<i className="icon-pencil"></i>
    </button>
  )
}
// Hoàn tiền đơn hàng
function RefundBtn(invoice) {
  return (
    <button style={{ marginRight: 10 }} onClick={() => this.handleRefundInvoice(invoice.id)} type="button" className="btn border-slate text-slate-800 btn-flat">
      Hoàn Tiền{" "}<i className="icon-rotate-ccw3"></i>
    </button>
  )
}
// Xuất hoá đơn
function VATRequestBtn(is_vat_bill, onShowInvoiceRequestModal) {
  return (
    <button style={{marginRight:10}} className="btn bg-purple" onClick={()=>onShowInvoiceRequestModal()}> 
      {!is_vat_bill ? "Yêu cầu xuất hóa đơn" : "Sửa thông tin công ty"}
    </button>
  )
}
// Huỷ đơn hàng
function CancelBtn(invoice, handleCancelInvoice) {
  return (
    <a href="#" style={{marginRight:10}} onClick={()=>handleCancelInvoice(invoice.id)} type="button" className="btn btn-danger">
      Hủy đơn hàng{" "}<i className="icon-cross2"></i>
    </a>
  )
}

// Thanh toán đơn hàng bằng tài khoản TADU
function TaduAccountPaidBtn(invoice, onTaduAccountPayment) {
  return (
    <button style={{color:'white', marginRight:10}} onClick={()=>onTaduAccountPayment()} type="button" className="btn btn-success">
      Thanh toán bằng tài khoản Tadu{" "}<i className="icon-coin-dollar"></i>
    </button>
  )
}

// Khởi tạo đơn hàng.
function ItemDeliveryBtn(invoice_item, addon_services, onShowItemRegisModal , setupRegisService, onShowItemRenewModal, setupUpgradeService) {
  let inner_delivery_btn = <button style={{color:'white', marginRight:10}} onClick={()=>onShowItemRegisModal (invoice_item)} type="button" className="btn btn-success">
    Chưa khởi tạo
  </button> 
  if(invoice_item.user_product && !["IP", "WHOIS_PRIVACY"].includes(invoice_item.product.product_type)) {
    inner_delivery_btn = (
      <React.Fragment>
        {invoice_item.user_product.status === "PENDING" && <button style={{color:'white', marginRight:10}} onClick={()=>setupRegisService(invoice_item)} type="button" className="btn btn-warning">
           Hoàn tất đơn hàng
        </button>}
        {invoice_item.is_renew && <button style={{color:'white', marginRight:10}} onClick={()=> onShowItemRenewModal(invoice_item, addon_services)} type="button" className="btn btn-warning">
           Gia hạn đơn hàng
        </button>}
        {invoice_item.is_upgrade && <button style={{color:'white', marginRight:10}} onClick={()=> setupUpgradeService(invoice_item)} type="button" className="btn btn-warning">
           Nâng cấp đơn hàng
        </button>}
      </React.Fragment>
    )
  }
  return inner_delivery_btn;
}

function VATRequestInfo(data, is_agency_invoice, onVATChangeStatus) {
  // nếu là đơn hàng HP thông tin xuất hoá đơn sẽ nằm ở table agency invoice
  data = is_agency_invoice ? data.invoice : data;
  const inner_vat_info = (
  data.is_vat_bill == true && <React.Fragment>
      <div className="card-footer">
        <div className="col-md-12" style={{textAlign:"left"}}>
          <strong>Thông tin xuất hóa đơn:</strong>
          <br/>
            <strong>Tên công ty: </strong>
            {data.vat_company_name}
          <br/>
            <strong>Địa chỉ công ty: </strong>
            {data.vat_company_address}
          <br/>
            <strong>Mã số thuế: </strong>
            {data.vat_mst}
          <br/>
            <strong>Email nhận hóa đơn: </strong>
            {data.express_address}
          <br />
          <div>
            <strong>Xuất hoá đơn theo giá: </strong>
            {data.user && data.user.agency_id ? EnumTranslate(data.vat_type): "Bán lẻ"}
            <br/>
          </div>
          <strong>Thanh toán VAT: </strong>
          {EnumTranslate(data.vat_bill_type)}
          <br/>
          <strong>Trạng Thái: {VATStatus(data.vat_status)}</strong>
        </div>
      </div>  
      <div className="card-footer">
        <button onClick={()=>onVATChangeStatus(data.id, "BDELAY")} style={{margin: 5}} className="btn bg-warning">Chờ Đối Tác Xuất</button>
        <button onClick={()=>onVATChangeStatus(data.id, "CPROCESS")} style={{margin: 5}} className="btn bg-orange">Tiến Hành Xuất</button>
        <button onClick={()=>onVATChangeStatus(data.id, "DFINISH")} style={{margin: 5}} className="btn bg-success">Hoàn Tất</button>
      </div>
    </React.Fragment>
  )
  return inner_vat_info;
}

function FooterGroup(user_role, data, handleRefundInvoice, onShowInvoiceRequestModal, handleCancelInvoice, onTaduAccountPayment, onSetInvoiceTrial, onPaypalPayment, handleReCalculatePrice) {
  let is_vat_bill = null;
  if(data.invoice) { // AgencyInvoice
    is_vat_bill = data.invoice.is_vat_bill
  } else {
    is_vat_bill = data.is_vat_bill
  }
  const footer_group = (
    <div className="row">
      <div className="col-sm-12">
        {InvoicePageRole.isSetTrialInvoice(user_role) && data.invoice_status === "NEW" && SetupProductBtn(data.id, onSetInvoiceTrial)}
        {/* {data.invoice_status == "NEW" && PaypalPaidBtn(data, onPaypalPayment)} */}
        {/* {data.invoice_status == "NEW" && TaduAccountPaidBtn(data, onTaduAccountPayment)} */}
        {user_role === "MASTER" && data.invoice_status !== "CANCEL" && VATRequestBtn(is_vat_bill, onShowInvoiceRequestModal)}
        {/* {data.invoice_status == "PAID" && RefundBtn(data, handleRefundInvoice)} */}
        {user_role === "MASTER" && data.invoice_status !== "CANCEL" && CancelBtn(data, handleCancelInvoice)}
        {/* {data.invoice_status != "CANCEL" && ReCalculatePriceBtn(data, handleReCalculatePrice)} */}
      </div>
    </div>
  )
  return footer_group;
}

function AgencyAdminInfo(agency) {
  // Tìm ra admin của đại lý, để show ra thông tin
  const agency_admin = _.find(agency.users, (i) => i.role == "AGENCY");
  return (
    <React.Fragment>
      <span style={{fontWeight: 'bold'}}>Thông Tin Đại lý</span>
      <ul className="list-condensed list-unstyled">
        <li>
          <h5>{agency_admin.full_name}</h5>
        </li>
        <li>
          <span className="text-semibold">
            {agency_admin.phone}
          </span>
        </li>
        <li>
          <a href="#">{agency_admin.email}</a>
        </li>
      </ul>
    </React.Fragment>
  )
}

class InvoiceItemRows extends React.Component {
  render() {
    const {user_role, role_path, invoice_items, invoice_status, templates, onShowItemRegisModal, onShowItemRenewModal} = this.props; 
    const {setupRegisService, setupUpgradeService, onChangeServiceInfo, onChangeDomainProfile, onRenewWhoisService} = this.props; 
    const allow_service_setup_status = ["UNPAID", "TRIAL", "PAID"];
    const item_invoice_rows = _.map(invoice_items, function (i, key) {
      if(!i.parent_id) {
        const product_type = i.product.product_type;
        // Nếu là không phải là sản phẩm theo năm thì nhân giá với tổng số tháng.
        const total_price = i.price_is_year || i.is_upgrade ? i.price : i.price * i.month;
        // Nhóm lại các addon theo dịch vụ cha.
        const addon_services = _.filter(invoice_items, (addon_item) => addon_item.parent_id === i.group_id);
        return (
          <tr key={key} style={{borderBottom: "1px solid #ddd"}}>
            <td>
              {CheckItemRegisStatus(i)}
            </td>
            <td>
              <h6 className="no-margin">
                {["VPS", "CLOUD_SERVER_PRO"].includes(product_type) && templates.length > 0 && VPSLabel(user_role, i, onChangeServiceInfo, templates, addon_services)}
                {product_type == "IP" && templates.length > 0 && IPAddonLabel(user_role, i)}
                {product_type == "WHOIS_PRIVACY" && templates.length > 0 && WhoIsAddonLabel(i)}
                {["VN_DOMAIN", "COM_DOMAIN"].includes(product_type) && DomainLabel(user_role, i, onShowItemRegisModal , onRenewWhoisService, role_path, addon_services)}
                {["LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type) && HostingLabel(user_role, i, onChangeServiceInfo, addon_services)}
                {product_type == "EMAIL" && EmailLabel(user_role, i, onChangeServiceInfo)}
                {product_type == "SSL" && SSLLabel(user_role, i, onChangeServiceInfo)}
                {product_type == "TADU_PHONE" && TaduphoneLabel(user_role, i, onChangeServiceInfo)}
                {product_type == "TADU_INVOICE" && TaduInvoiceLabel(user_role, i, onChangeServiceInfo)}
                {product_type == "CLOUD_BACKUP" && CloudBackupLabel(user_role, i, onChangeServiceInfo)}
                {product_type == "DIGITAL_SIGNATURE" && DigitalSignatureLabel(user_role, i, onChangeServiceInfo)}
              </h6>
                <React.Fragment> 
                  {i.domain_profile_id && <Link className="mr-2" to={role_path + "/customer/profile/detail/"+i.domain_profile_id}>[Bản khai]</Link> }
                  {DomainProfileModifyBtn(user_role, i, onChangeDomainProfile)}
                </React.Fragment>
            </td>
            <td>
              {i.month} Tháng
              <br/>
              {i.extra_month > 0 && <small style={{color: 'orange'}} > + {i.extra_month} Tháng</small>}
            </td>
            <td>
              <center>
                {InvoicePageRole.isAllowSetupInvoiceItem(user_role) && !i.is_delivery && allow_service_setup_status.includes(invoice_status) ?  ItemDeliveryBtn(i, addon_services, onShowItemRegisModal , setupRegisService, onShowItemRenewModal, setupUpgradeService) : DeliveryStatus(i)}
              </center>
            </td>
            {InvoicePageRole.isShowInvoiceMoney(user_role) && <td style={{textAlign: "right"}}>
              <span className="text-semibold">{numeral(total_price).format("0,0")} đ</span>
              <br/>
              {AddonPriceLabel(i, addon_services)}
            </td>}
          </tr>
        )
      }
    })
    return item_invoice_rows;
  }
}

class InvoiceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice_result: null,
      templates: [],
      is_show_invoice_request_modal: false,
      is_show_item_regis_modal: false,
      is_show_item_renew_modal: false,
      is_show_service_info_change_modal: false,
      is_show_domain_profile_modify_modal: false,
      alert_label: null,
      invoice_item_selected: null,
      addon_items: null,
      isLoading: false
    };
  }

  // Dùng để hiển thị các thông báo khi người dùng thực thi các chức năng
  onShowAlertMessage = (status, message) => {
    this.setState({
      alert_label: {status: status, message: message}
    })
  }

  // Hoàn tất khởi tạo dịch vụ đăng ký mới
  setupRegisService = (invoice_item) => {
    const { invoice_result } = this.state;
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ hoàn tất khởi tạo ?.");
    if(alert_confirm) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + "/admin/api/finish/pending/service/invoice",
        withCredentials: true,
        data: {
          invoice_item_id: invoice_item.id,
          invoice_code: invoice_result.code,
          user_product_id: invoice_item.user_product.id
        }
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          self.onHideModal();
        }else {
          toast.error(response.data.error);
        }
      });
    }
  }

  // Hoàn tất khởi tạo dịch vụ nâng cấp.
  setupUpgradeService = (invoice_item) => {
    const self = this;
    const { invoice_result } = this.state;
    const alert_confirm = window.confirm("Bạn có chắc sẽ nâng cấp dịch vụ này ?.");
    if(alert_confirm && !["WHOIS_PRIVACY", "IP", "VN_DOMAIN", "COM_DOMAIN", "DIGITAL_SIGNATURE"].includes(invoice_item.product.product_type)) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + "/admin/api/setup/upgrade/invoice",
        withCredentials: true,
        data: {
          invoice_item_id: invoice_item.id,
          invoice_code: invoice_result.code,
          user_product_id: invoice_item.user_product.id,
          product_upgrade_id: invoice_item.product_id
        }
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          self.onHideModal();
        }
      });
    }
  }

  // Gia Hạn Addon Whois Privacy
  renewWhoisService = (parent_id, addon_item) => { 
    const self = this;
    const { invoice_result } = this.state;
    const data = {
      invoice_item_id: addon_item.id,
      invoice_code: invoice_result.code,
      parent_id: parent_id,
    }
    const alert_confirm = window.confirm("Bạn có chắc sẽ gia hạn WHOIS PRIVACY ?.");
    if(alert_confirm) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + "/admin/api/setup/renew/whois/addon/invoice",
        withCredentials: true,
        data: data,
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          self.onHideModal();
        }
      });
    }
  }

  reload = () => {
    const { invoice_id } = this.props.match.params;
    const { is_agency_invoice } = this.props;
    const self = this;
    let url = window.api_url + '/admin/api/invoice/detail/' + invoice_id;
    // Kiểm tra đơn hàng có phải agency không.
    if(is_agency_invoice) {
      url = window.api_url + '/admin/api/invoice/agency/detail/' + invoice_id;
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        ...self.state,
        invoice_result: response.data.data,
      })
    });

    axios({
      method: 'get',
      url: window.api_url + '/api/product/vps/template',
      withCredentials: true
    }).then(function (response) {
      self.setState({
        ...self.state,
        templates: response.data.data
      })
    });
  }

  // Chấp nhận đơn hàng.
  // Note: Sử dụng cho đơn hàng HP.
  handleAcceptInvoice = (invoice) => {

  }

  // Chức năng setup trước.
  onSetInvoiceTrial = (invoice_id) => {
    // /invoice/setup_trial_invoice
    const alert_confirm = window.confirm("Bạn có chắc sẽ setup trước đơn hàng này ?.");
    const self = this;

    if(alert_confirm) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })

      axios({
        method: 'post',
        url: window.api_url + '/admin/api/invoice/setup_trial_invoice',
        withCredentials: true,
        data: {
          invoice_id: invoice_id
        }
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        self.reload();
      });
    }
  }

  // Thanh toán bằng Paypal. 
  onPaypalPayment = (invoice) => {
  
  }
  
  // Tính lại giá hoá đơn.
  handleReCalculatePrice = (invoice) => {

  }
  
  // Hoàn lại tiền.
  handleRefundInvoice = (invoice) => {

  }

  // Thay đổi thông tin dịch vụ
  // VD: VPS template, hosting domain...
  onChangeServiceInfo = ( invoice_item ) => {
    this.setState({
      is_show_service_info_change_modal: true,
      invoice_item_selected: invoice_item
    })
  }

  // Thay bản khai tên miền tin dịch vụ
  onChangeDomainProfile = ( invoice_item ) => {
    this.setState({
      is_show_domain_profile_modify_modal: true,
      invoice_item_selected: invoice_item
    })
  }
  
  // Hiển thị Modal Popup điền thông tin xuất hoá đơn.
  onShowInvoiceRequestModal = () => {
    this.setState({
      is_show_invoice_request_modal: true
    })
  }

  // Ẩn Modal và làm tươi tại dữ liệu
  onHideModal = () => {
    this.setState({
      is_show_invoice_request_modal: false,
      is_show_item_regis_modal: false,
      is_show_item_renew_modal: false,
      invoice_item_selected: null,
      is_show_tadu_note_modal: false,
      is_show_service_info_change_modal: false,
      is_show_domain_profile_modify_modal: false
    })
    this.reload();
  } 

  // Hiện modal khởi tạo dịch vụ.
  onShowItemRegisModal = (invoice_item) => {
    this.setState({
      is_show_item_regis_modal: true, 
      invoice_item_selected: invoice_item
    })
  }

  // Hiện modal gia hạn dịch vụ.
  onShowItemRenewModal = (invoice_item, addon_items) => {
    this.setState({
      is_show_item_renew_modal: true, 
      invoice_item_selected: invoice_item,
      addon_items: addon_items
    })
  }

  // Huỷ đơn hàng.
  handleCancelInvoice = (invoice_id) => {
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ hủy đơn hàng này ?.");
    if(alert_confirm) {
      axios({
        method: 'post',
        url: window.api_url + '/api/user/invoice_cancel',
        withCredentials: true,
        data: {
          invoice_id: invoice_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          self.onShowAlertMessage("SUCCESS", "Huỷ đơn hàng thành công.");
          self.reload();
        } else {
          self.onShowAlertMessage("ERROR", "Hủy đơn hàng thất bại.");
        }
      });
    }
  }

  handleShowTaduNoteModal = () => {
    this.setState({
      is_show_tadu_note_modal: true
    })
  }

  // Thanh toán bằng Tadu Account
  onTaduAccountPayment = () => {
    const { invoice_result } = this.state;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice_payment',
      data: invoice_result,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.onShowAlertMessage("SUCCESS", "Thanh toán đơn hàng thành công.");
        self.reload();
      } else {
        self.onShowAlertMessage("ERROR", "Bạn không đủ tiền trong tài khoản để thanh toán đơn hàng này.");
      }
    });
  }

  exportPdf(invoice, templates) {
    const data_export = InvoicePDFTemplate.getDataExport(invoice, templates)
    if (data_export) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.createPdf(data_export).download('don-hang-'+ invoice.code);
    }   
  }

  // Thay đổi trạng thái yêu cầu xuất hóa đơn
  onVATChangeStatus = (invoice_id, vat_status) => {
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/vat_request/change_status',
      data: {
        invoice_id: invoice_id,
        vat_status: vat_status
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.onShowAlertMessage("SUCCESS", "Thay đổi trạng thái hóa đơn thành công");
        self.reload();
      } else {
      }
    });
  }

  componentDidMount() {
    this.reload(); 
  }

  render() {
    const {invoice_result, templates, alert_label, is_show_invoice_request_modal, is_show_item_regis_modal} = this.state;
    const { invoice_item_selected, is_show_tadu_note_modal, is_show_domain_profile_modify_modal, is_show_service_info_change_modal, isLoading } = this.state;
    const { addon_items, is_show_item_renew_modal} = this.state;
    const { is_agency_invoice, userProfile, role_path } = this.props;
    return (
      userProfile && <React.Fragment>
        {isLoading && <BlockUI />}
        <ToastContainer/>
        <div className="page-header">
          <h4>
            <i className=" icon-paragraph-justify2 position-left"></i>
            <span className="text-semibold"> Chi Tiết Đơn Hàng</span>
          </h4>
        </div>
        {invoice_result && <div className="card">
          <div style={{ borderBottom: "1px solid", borderBottomColor: "#ddd"}}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-sm-6">
                  <h6 style={{margin:10}} className="panel-title">Hóa đơn</h6>
                </div>
                <div className="col-sm-6">
                  {InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <button style={{float:"right"}} type="button" onClick={()=> this.exportPdf(invoice_result, templates)} className="btn btn-default btn-xs">
                    <h6 style={{margin:5}} className="panel-title"><i className="icon-printer position-left"></i> In</h6>
                  </button>}
                </div>
              </div> 
            </div>
          </div>
          <div className="card-body">
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}   />}
            <div className="row">
              <div className="col-sm-6 content-group">
                <span style={{fontWeight: 'bold'}}>Thông tin khách hàng:</span>
                <ul className="list-condensed list-unstyled">
                  <li>
                    <h5>{invoice_result.user.full_name}</h5>
                  </li>
                  <li>
                    <span className="text-semibold">
                      {invoice_result.user.phone}
                    </span>
                  </li>
                  <li>
                    <a href="#">{invoice_result.user.email}</a>
                  </li>
                </ul>
                {invoice_result.user.agency && AgencyAdminInfo(invoice_result.user.agency)}
              </div>
              <div className="col-sm-6 content-group" style={{width: "auto"}}>
                <div style={{float:"right"}} className="invoice-details">
                  <h5 className="text-uppercase text-semibold"># <strong>{invoice_result.code}</strong></h5>
                  <ul className="list-condensed list-unstyled">
                    <li>
                      <strong>Ngày đăng ký:</strong>{" "}
                      <span className="text-semibold">{invoice_result.created_date}</span>
                    </li>
                    {invoice_result.payment_date &&<li>
                      <strong>Ngày Thanh Toán:</strong>{" "}
                      <span className="text-semibold">{invoice_result.payment_date}</span>
                    </li>}
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-9 content-group"></div>
                <div className="col-md-6 col-lg-3">
                  <span style={{fontWeight: 'bold'}}>Thông Tin Thanh Toán:</span>
                  <ul className="list-condensed list-unstyled">
                    <li>
                      {userProfile && InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <h5>
                        Tổng Tiền:{" "}
                        <span style={{float:"right"}} className="text-right text-semibold">
                          {numeral(invoice_result.total).format("0,0")} đ
                        </span>
                      </h5>}
                    </li>
                    <li>
                      Trạng thái:
                      <span className="text-semibold">
                        <span style={{float:"right"}} className="label label-info">{InvoiceStatus(invoice_result.invoice_status)}</span>
                      </span>
                    </li>
                    <li>
                      Hình thức thanh toán: <span style={{float:"right"}}>{invoice_result.payment_type}</span>
                    </li>
                  </ul>
                </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h6>Ghi chú đơn hàng: </h6>
                <pre style={{border: "none"}} className="text-muted">{invoice_result.note}</pre>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-lg">
              <thead>
                <tr style={{ backgroundColor: "#007DC6",color: "#fff"}}>
                  <th style={{ width: "150px" }} >Loại</th>
                  <th style={{ width: "350px" }} >Dịch vụ</th>
                  <th style={{ width: "140px" }} >Tháng</th>
                  <th style={{ textAlign: "center", width: "140px" }} >Trạng Thái</th>
                  {InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <th style={{ width: "200px", textAlign: "right" }}> Thành tiền </th>}
                </tr>
              </thead>
              <tbody>
                {<InvoiceItemRows 
                  user_role={userProfile.role}
                  role_path={role_path}
                  invoice_items = {invoice_result.invoice_items}
                  invoice_status = {invoice_result.invoice_status}
                  templates = {templates}
                  onShowItemRegisModal = {this.onShowItemRegisModal}
                  onShowItemRenewModal={this.onShowItemRenewModal}
                  setupRegisService={this.setupRegisService}
                  setupUpgradeService={this.setupUpgradeService} 
                  onChangeServiceInfo={this.onChangeServiceInfo}
                  onRenewWhoisService={this.renewWhoisService}
                  onChangeDomainProfile={this.onChangeDomainProfile}/>}
              </tbody>
            </table>
          </div>

          {InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <div className="card-body">
            <div className="row invoice-payment">
              <div className="col-sm-7"></div>
              <div className="col-sm-5">
                <br/>
                <div className="content-group">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        <tr style={{borderTop: "1px solid #ddd"}}>
                          <th>Tổng tiền:</th>
                          <td className="text-right">{numeral(invoice_result.sub_total).format("0,0")} đ</td>
                        </tr>
                        <tr>
                          <th>Giảm giá:</th>
                          <td className="text-right">{numeral(invoice_result.discount_money).format("0,0")} đ</td>
                        </tr>
                        <tr>
                          <th>Còn lại:</th>
                          <td className="text-right">{numeral(invoice_result.sub_total - invoice_result.discount_money).format("0,0")} đ</td>
                        </tr>
                        <tr>
                          <th>
                            VAT: <span className="text-regular">(10%)</span>
                          </th>
                          <td className="text-right">{numeral(invoice_result.tax_money).format("0,0")} đ</td>
                        </tr>
                        <tr>
                          <th>Thành tiền:</th>
                          <td className="text-right text-primary">
                            <h5 className="text-semibold">{numeral(invoice_result.total).format("0,0")} đ</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br/>
                </div>
              </div>
            </div>
          </div>}
          {InvoicePageRole.isShowTaduNote(userProfile.role) && <div className="card-footer">
            <div>
              <strong>Kỹ Thuật Ghi chú </strong>
              <a href="#" onClick={() => this.handleShowTaduNoteModal()}><i className="icon-pencil7"></i></a>
              <br/>
              {ReactHtmlParser(invoice_result.tadu_note)}
            </div>
          </div>}

          {<div style={{textAlign:"right"}} className="card-footer">
            {invoice_result && invoice_result.code.startsWith("TADU-") &&  FooterGroup(
              userProfile.role,
              invoice_result,
              this.handleRefundInvoice,
              this.onShowInvoiceRequestModal,
              this.handleCancelInvoice,
              this.onTaduAccountPayment,
              this.onSetInvoiceTrial,
              this.onPaypalPayment,
              this.handleReCalculatePrice,
              this.handleAcceptInvoice)}
          </div>}
          {invoice_result && InvoicePageRole.isVATRequestAction(userProfile.role) && VATRequestInfo(invoice_result, is_agency_invoice, this.onVATChangeStatus)}
        </div>}

        {/* Popup yêu cầu xuất hóa đơn */}
        {is_show_invoice_request_modal && <InvoiceRequestModal 
          onShowAlertMessage={this.onShowAlertMessage} 
          title="Yêu Cầu Xuất Hoá Đơn" 
          is_agency_invoice={is_agency_invoice} 
          // Nếu là AgencyInvoice, thì lấy Invoice Preload từ AgencyInvoice
          invoiceObject={invoice_result.invoice ? invoice_result.invoice : invoice_result} 
          show={is_show_invoice_request_modal} 
          onHide={this.onHideModal} />
        }

        {/* Popup khởi tạo dịch vụ */}
        {/* Thủ công hoặc tự động */}
        {is_show_item_regis_modal && <ItemRegisModal 
          title="Khởi tạo dịch vụ" 
          customer_id = {invoice_result.user.id}
          invoice_item_obj={invoice_item_selected}
          invoice_code = {invoice_result.code}
          show={is_show_item_regis_modal} 
          onHide={this.onHideModal}/>}

        {/* Popup gia hạn dịch vụ */}
        {/* Thủ công hoặc tự động */}
        {is_show_item_renew_modal && <ItemRenewModal 
          title="Gia Hạn Dịch Vụ" 
          customer_id = {invoice_result.user.id}
          invoice_item_obj={invoice_item_selected}
          addons = {addon_items}
          product_type={invoice_item_selected.product.product_type}
          invoice_code = {invoice_result.code}
          show={is_show_item_renew_modal} 
          onHide={this.onHideModal}/>}

        {/* Popup Ghi Chú cho kỹ thuật */}
        {is_show_tadu_note_modal && <TaduNoteModal
          title="Ghi chú"
          invoice_code = {invoice_result.code}
          show = {is_show_tadu_note_modal}
          onHide = {this.onHideModal}
        />}

        {/* Popup thay đổi thông tin dịch vụ. */}
        {is_show_service_info_change_modal && <ChangeServiceInfo
          title="Thay đổi thông tin dịch vụ"
          templates = {templates}
          invoice_item_obj={invoice_item_selected}
          show = {is_show_service_info_change_modal}
          onHide = {this.onHideModal}
        />}

        {/* Popup thay đổi thông tin dịch vụ. */}
        {is_show_domain_profile_modify_modal && <ChangeDomainProfileModal
          title="Thay đổi bản khai"
          rolePath={role_path}
          invoice_item_obj={invoice_item_selected}
          // Nếu là AgencyInvoice, thì lấy Invoice Preload từ AgencyInvoice
          invoiceObject={invoice_result.invoice ? invoice_result.invoice : invoice_result} 
          show = {is_show_domain_profile_modify_modal}
          onHide = {this.onHideModal}
        />}
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  role_path: state.userProfile.role_path,
  userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({

});

export default connect(mapState, mapDispatch)(withRouter(InvoiceDetail));
